import _ from "lodash";
import { Types } from "./paymentIntegrationActions";

const paymentIntegrationReducers = (state, action) => {
	switch (action.type) {
		case Types.PAYMENT_INTEGRATION_UPDATE_EMPLOYEE: {
			let newState = _.cloneDeep(state);

			if (action.paymentIntegrationId) {
				newState.employee.employeeDetails.paymentIntegrationId = action.paymentIntegrationId;
			}

			if (action.pending) {
				newState.employee.employeeDetails.paymentIntegrationPending = action.pending;
			} else if (newState.employee.employeeDetails.paymentIntegrationPending) {
				delete newState.employee?.emplyoeeDetails?.paymentIntegrationPending;
			}

			return newState;
		}
		case Types.PAYMENT_INTEGRATION_SYNCING_STATUS: {
			let newState = _.cloneDeep(state);

			if (action.unsyncedEmployees) {
				newState.integration.payment[action.integration].unsyncedEmployees = action.unsyncedEmployees;
			}
			if (action.error) {
				newState.integration.payment[action.integration].syncError = action.error;
			}
			if (action.syncingStatus) {
				newState.integration.payment[action.integration].syncingStatus = action.syncingStatus;
			}
			return newState;
		}
		case Types.PAYMENT_INTEGRATION_UPDATE_FIELD: {
			let newState = _.cloneDeep(state);

			if (!newState.integration.payment[action.integration].details) {
				newState.integration.payment[action.integration].details = {};
			} else {
				newState.integration.payment[action.integration].details = {
					...newState.integration.payment[action.integration].details,
				};
			}

			newState.integration.payment[action.integration].details[action.field] = action.value;
			return newState;
		}

		case Types.PAYMENT_INTEGRATION_SAVING: {
			let newState = _.cloneDeep(state);

			newState.integration.payment[action.integration] = {
				...(newState.integration.payment[action.integration] ?? {}),
				saving: true,
			};

			return newState;
		}
		case Types.PAYMENT_INTEGRATION_SAVE: {
			let newState = _.cloneDeep(state);

			newState.integration.payment[action.integration] = {
				...(newState.integration.payment[action.integration] ?? {}),
				...action.data,
				saving: false,
			};

			return newState;
		}
		case Types.PAYMENT_INTEGRATION_PAYMENT_STAGE: {
			let newState = _.cloneDeep(state);

			newState.integration.payment[action.integration].stage = action.stage;

			return newState;
		}
		case Types.PAYMENT_INTEGRATION_COMPANIES: {
			let newState = _.cloneDeep(state);

			newState.integration.payment[action.integration].companies = action.companies;

			return newState;
		}
		case Types.PAYMENT_INTEGRATION_ACCOUNTS: {
			let newState = _.cloneDeep(state);

			newState.integration.payment[action.integration].accounts = action.accounts;

			return newState;
		}
		case Types.PAYMENT_INTEGRATION_PAY_PERIOD: {
			let newState = _.cloneDeep(state);
			const { payPeriods } = newState.integration?.payment?.[action.integration] || {};

			const period = action.response;

			const updatedPayPeriods = (() => {
				const existingPayPeriod = payPeriods.find((p) => p.payPeriodId === period.payPeriodId);

				if (existingPayPeriod) {
					return payPeriods.map((p) => (p.payPeriodId === period.payPeriodId ? period : p));
				} else {
					return [...payPeriods, period];
				}
			})();

			newState.integration.payment = {
				...newState.integration?.payment,
				[action.integration]: {
					...newState.integration?.payment?.[action.integration],
					payPeriods: updatedPayPeriods,
				},
			};
			return newState;
		}

		default:
			return state;
	}
};

export default paymentIntegrationReducers;
